import IframeActivity from "./IframeActivity";

export default function ObservationSkills() {
    return (
        <IframeActivity
            src="/activities/observation-skills/index.html"
            title="Observation Skills"
        />
    );
}